import React, { Component } from "react";
import { config } from "./../../constants";
class BannerContentLeft extends Component {
  render() {
    return (
      <div>
        <div className={"head-left"}>
        เปิดบัญชีออนไลน์ พร้อมยืนยันตัวตน
        </div>
        <p className={"banner-left-p"}>
          เปิดบัญชีเพื่อใช้บริการของ {config.WEB_NAME}
          <br />
          ผ่านช่องทางออนไลน์พร้อมยืนยันตัวตน
          <br />
          สะดวก รวดเร็ว ปลอดภัย ไม่ต้องจัดส่งเอกสาร
          <br />
          เปิดบัญชีและเทรดได้ทันที
        </p>
        <div className={"banner-left-tel"}>
          DAOL Contact Center 0 2351 1800
          <br />
        </div>
      </div>
    );
  }
}

export default BannerContentLeft;
